import React from 'react';
import { RouterProvider } from 'react-router-dom';
import ROUTES from 'domain/helpers/routes';

function App() {
  return <RouterProvider router={ROUTES} basename='/zoom' />;
}

export default App;
